import {
    FacebookIcon,
    GlobeIcon,
    InstagramIcon,
    LinkedinIcon,
    PinterestIcon,
    type ProductIcon,
    ThreadsIcon,
    TiktokIcon,
    XBrandIcon,
    YoutubeIcon,
} from "@wags/ui/product-icons.tsx";
import type {
    ProviderSocialLink,
    SocialPlatform,
} from "./provider-social-links";

const SOCIAL_ICONS: Record<SocialPlatform, ProductIcon> = {
    facebook: FacebookIcon,
    instagram: InstagramIcon,
    youtube: YoutubeIcon,
    x: XBrandIcon,
    pinterest: PinterestIcon,
    tiktok: TiktokIcon,
    threads: ThreadsIcon,
    linkedin: LinkedinIcon,
};

export function SocialLinksColumn({ links }: { links: ProviderSocialLink[] }) {
    return (
        <ul className="-my-2">
            {links.map((link) => {
                const Icon = link.platform
                    ? SOCIAL_ICONS[link.platform]
                    : GlobeIcon;
                return (
                    <li key={link.href}>
                        <a
                            href={link.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex min-h-11 items-center gap-3 rounded-nested py-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-labrador-yellow"
                        >
                            <span className="flex size-9 shrink-0 items-center justify-center rounded-nested bg-true-black/4 text-doberman-black">
                                <Icon aria-hidden className="size-5" />
                            </span>
                            <span className="min-w-0">
                                <span className="block truncate text-body font-medium text-doberman-black">
                                    {link.name}
                                </span>
                                {link.handle && (
                                    <span className="block truncate text-body-small text-doberman-black/50">
                                        {link.handle}
                                    </span>
                                )}
                            </span>
                        </a>
                    </li>
                );
            })}
        </ul>
    );
}
